import { widgetStore } from '../store';
import { useSelectedFieldStore } from './useSelectedFieldStore';

export type UseWidgetResultStateArg = {
  widgetId: string;
};

export function useWidgetResultState({ widgetId }: UseWidgetResultStateArg) {
  const widgetResultState = useSelectedFieldStore(
    widgetStore,
    () => widgetStore.get()[widgetId]?.widgetResultState
  );
  return widgetResultState;
}
